import React, { useEffect, useRef } from "react";
import Lotsize from "./lotsize";
import { useRouter } from 'next/router';
import Link from "next/link";
import SeoHead from '../../component/SeoHead';
import metaData from '../../data/Meta.json';
import { jsonLdByPath } from '../../data/SchemaTag.js';
export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}
const Pip_calculator = ({ meta, jsonLd }) => {
  const currencychart = useRef(null);
  const router = useRouter();
  const path = router.pathname;

  const fullPath = router.asPath;
  const segments = fullPath.split("/").filter(Boolean);
  const SecondPath = segments[segments.length - 1]

  useEffect(() => {
    const WidgetConfig = {
      Url: "https://www.cashbackforex.com",
      TopPaneStyle:
        "YmFja2dyb3VuZDogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggYmxhY2s7IGJvcmRlci1ib3R0b206IG5vbmU7IA==",
      BottomPaneStyle:
        "YmFja2dyb3VuZDogd2hpdGU7IGJvcmRlcjogc29saWQgMXB4IGJsYWNrOyBjb2xvcjogYmxhY2s7",
      ButtonStyle:
        "YmFja2dyb3VuZDogb3JhbmdlOyBjb2xvcjogd2hpdGU7IGJvcmRlci1yYWRpdXM6IDIwcHg7",
      TitleStyle:
        "dGV4dC1hbGlnbjogbGVmdDsgZm9udC1zaXplOiA0MHB4OyBmb250LXdlaWdodDogNTAwOw==",
      TextboxStyle:
        "YmFja2dyb3VuZC1jb2xvcjogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggI2FhYWFhYQ==",
      ContainerWidth: "900",
      DefaultInstrument: "EUR-USD",
      HighlightColor: "#ffff00",
      IsDisplayTitle: true,
      IsShowChartLinks: false,
      IsShowEmbedButton: false,
      CompactType: "large",
      Calculator: "pip-value-calculator",
      ContainerId: "pip-value-calculator-397910",
    };

    const container = document.getElementById(WidgetConfig.ContainerId);
    if (!container) return;

    const iframe = document.createElement("iframe");
    iframe.setAttribute("calc-id", "ifrm-cbf-" + WidgetConfig.ContainerId);
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("widgetType", "calculator");
    iframe.style = "width:100%; border: 0; height:100%; min-height:500px";

    let src = WidgetConfig.Url + "/widgets/" + WidgetConfig.Calculator;
    src += "?IsDisplayTitle=" + WidgetConfig.IsDisplayTitle;
    src += "&ShowChartLinks=" + WidgetConfig.IsShowChartLinks;
    src += "&TopPaneStyle=" + WidgetConfig.TopPaneStyle;
    src += "&BottomPaneStyle=" + WidgetConfig.BottomPaneStyle;
    src += "&ButtonStyle=" + WidgetConfig.ButtonStyle;
    src += "&TitleStyle=" + WidgetConfig.TitleStyle;
    src += "&TextboxStyle=" + WidgetConfig.TextboxStyle;
    src += "&MaxWidth=" + WidgetConfig.ContainerWidth;
    src += "&ContainerId=" + WidgetConfig.ContainerId;
    src += "&CompactType=" + WidgetConfig.CompactType;
    src += "&HighlightColor=" + encodeURIComponent(
      WidgetConfig.HighlightColor
    );
    src += "&DefaultInstrument=" + encodeURIComponent(
      WidgetConfig.DefaultInstrument
    );
    src += "&IsShowEmbedButton=" + WidgetConfig.IsShowEmbedButton;

    iframe.src = src;

    container.style = `position: relative; max-width: ${WidgetConfig.ContainerWidth}px;`;
    container.innerHTML = "";
    container.appendChild(iframe);

    // Message listener
    const onRemoteCalcMessage = (event) => {
      const data = event.data;
      if (typeof window[data.func] === "function") {
        window[data.func].call(null, data);
      }
    };

    window.addEventListener("message", onRemoteCalcMessage);
    return () => {
      window.removeEventListener("message", onRemoteCalcMessage);
    };
  }, []);

  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="pipcalculator">
        <section className="pipacal">
          <div className="pipcaltrade">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center">
                  <h1 className="px-3 mb-2">Copy trade Smarter with the Advanced Trader Calculator!</h1>
                  <p className="px-3 mb-3">
                    The Forex Calculator provides precise calculations for required margin, pip value, profit, and point value for any trading position, ensuring accurate and efficient copy trade management.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <img
                    src={"/images/pipcalc/Sell.gif"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* mainsec */}
        <section className="fpipcalc mt-5 pb-5">
          <div className="container">
            <div className="forexcal">
              <div className="row">
                {/* <div className="col-md-12 col-lg-2"> */}
                {/* <div className="imgad1">
                    <img
                      src={"/images/pipcalc/adbannerpip.png"}
                      alt="logo"
                      className="img-fluid"
                    />
                  </div> */}
                {/* </div> */}
                <div className="col-md-12 col-lg-12">
                  <div className="pipcalsacc">
                    <div className="row">
                      <div className="col-md-12 col-lg-4">
                        <div className="forexcalcc">
                          <div className="card">
                            <div className="card-title px-4 my-3">
                              <h4>Forex Calculators</h4>
                            </div>
                            <div className="card-body pt-0 mt-0">
                              <div className="nav-tabs-menu mt-0">
                                <ul
                                  className="nav nav-tabs d-block"
                                  id="ProductTab"
                                  role="tablist"
                                >
                                  <li
                                    className="nav-item d-flex"
                                    role="presentation"
                                  >
                                    <Link href={'/pip-calculator'}>
                                      <button
                                        className="nav-link active"
                                        id="Pip-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#Pip"
                                        type="button"
                                        role="tab"
                                        aria-controls="Pip"
                                        aria-selected="true"
                                      // onClick={pipcalcu}
                                      >
                                        Pip Calculator
                                      </button>
                                    </Link>
                                  </li>
                                  <li className="nav-item" role="presentation">
                                    <Link href={'/pip-calculator/lotsize'}>
                                      <button
                                        className="nav-link"

                                      >
                                        Lot Size Calculator
                                      </button>
                                    </Link>
                                  </li>
                                  <li className="nav-item" role="presentation">
                                    <Link href={'/pip-calculator/forex-profit-calculator'}>
                                      <button
                                        className="nav-link"
                                        id="Profit-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#Profit"
                                        type="button"
                                        role="tab"
                                        aria-controls="Profit"
                                        aria-selected="false"
                                      // onClick={profitcalu}
                                      >
                                        Profit Calculator
                                      </button>
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-8">
                        <div className="pipc">
                          <div className="tab-content" id="ProductTabContent">
                            <div
                              className="tab-pane fade active show"
                              id="Pip"
                              role="tabpanel"
                              aria-labelledby="Pip-tab"
                            >
                              <div
                                id="pip-value-calculator-397910"
                                ref={currencychart}
                              ></div>
                            </div>

                            <div
                              className="tab-pane fade"
                              id="Lotsize"
                              role="tabpanel"
                              aria-labelledby="Lotsize-tab"
                            >
                              {" "}
                              <h2 className="mb-3">Lot Size Calculator</h2>
                              <Lotsize />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="Profit"
                              role="tabpanel"
                              aria-labelledby="Profit-tab"
                            >
                              {" "}
                              <forex-profit-calculator />
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className="pips">
                        {" "}
                        For all transactions, these are available at your
                        disposal. You can use this helpful calculator to
                        determine the volume for all instruments and the long
                        and short swaps, margin, and benefits points that are
                        all part of your trading positions.
                      </p>
                    </div>
                    {path === "/pip-calculator" ? (
                      <>
                        <div className="row align-items-center">
                          <div className="col-md-12 col-lg-4">
                            {" "}
                            <img
                              src={"/images/pipcalc/profit.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="col-md-12 col-lg-8">
                            <p>
                              A pip, or &quot;pipette,&quot; is the slightest possible
                              price movement for a currency pair in the forex
                              world.
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {SecondPath && SecondPath === "lotsize" ? (
                      <>
                        <div className="row align-items-center">
                          <div className="col-md-12 col-lg-4">
                            <img
                              src={"/images/pipcalc/lot.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="col-md-12 col-lg-8">
                            <p className="">
                              A &quot;Lot&quot; in forex designates the copy trade size or the
                              quantity of currency units purchased or sold in a
                              transaction. One hundred thousand units of the
                              base currency make up a standard lot. Most brokers
                              also provide trading with fractional lot sizes,
                              often as standard lot 1.00, Mini lots (0.10),
                              micro lots (0.01), and lots are the three
                              categories for fractional lot sizes (0.001).
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {SecondPath && SecondPath === "forex-profit-calculator" ? (
                      <>
                        <div className="row align-items-center">
                          <div className="col-md-12 col-lg-4">
                            <img
                              src={"/images/pipcalc/forex-profit-calculator.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="col-md-12 col-lg-8">
                            <p className="">
                              A forex profit calculator helps simulate the
                              amount of money and pip the position will
                              represent. It operates by emulating a trading
                              position that is opened and closed at
                              predetermined prices; the possible profit or loss
                              outcomes are shown in dollars and Point in
                              Percentage (pips). Calculation of a Pip Value for
                              CFD’s: The pip value calculator uses real-time
                              market quotations, the account base currency, the
                              lot size, and the traded pair to precisely
                              determine the pip value for currency pairings,
                              indices, digital currencies, and more.
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {/* <div className="col-md-12 col-lg-2"> */}
                {/* <div className="imgad2">
                    <img
                      src={"/images/pipcalc/adbannerpip2.png"}
                      alt="logo"
                      className="img-fluid"
                    />
                  </div> */}
                {/* </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Pip_calculator;
